import React from 'react';
import { Dialog, Grid, FormGroup, InputAdornment, Checkbox, FormControl, MenuItem, Stack } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import flightStyles from './flights.module.css';
import { CustomButton, CustomDialogTitle, StyledCard, CustomTextField, CustomDatePicker, CustomCheckbox, CustomSelect, CustomInputLabel, CustomDialogAction, InputProps, CustomAutocomplete, SelectInputProps, CustomDialogContent } from '../../../../../custom/components';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import dayjs from 'dayjs';
import moment from 'moment';
import { CloseIconBtn, TickIcon } from 'custom/constants';

const platforms = [
  'Pax',
  'Freighter',
  'Domestic Pax',
  'Domestic Freighter',
  'Truck',
];

// Reusable form content, usable standalone or wrapped in a Dialog.
export const FlightScheduleForm = (props) => {
  return (
    <>
      <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>{props.flightFields?.conflictId ? (props.flightFields?.existing ? 'Existing' : 'New') : props.flightFields?.id != 0 ? 'Edit' : 'Add'} Flight Schedule
        <CloseIconBtn onClick={() => props.handleCloseSchedule('add')} />
      </CustomDialogTitle>
      <form onSubmit={(e) => props.addSchedule(e, props.dataIndex)} className={styles.w100}>
        <CustomDialogContent>
          <StyledCard>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <CustomInputLabel id='airline-label' aria-label='Enter-airline' required>Airline{props.dataIndex}</CustomInputLabel>
                <FormControl variant='standard' fullWidth error={props.flightErrors?.airline}>
                  <CustomSelect
                    {...SelectInputProps}
                    id='airline'
                    labelId='airline-label'
                    fullWidth
                    autoFocus
                    onChange={(e) => props.onChange(e, null, props.dataIndex)}
                    name='airline'
                    value={!props.flightFields?.airline ? 'placeholder' : props.flightFields.airline}
                    classes={{ select: !props.flightFields?.airline ? styles.colorPlaceholder : '' }}
                  >
                    <MenuItem value='placeholder' disabled>Select an airline</MenuItem>
                    {props.airlines.map((airline, i) => (
                      <MenuItem key={i} value={airline.code}>
                        {airline.code}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInputLabel htmlFor='number' aria-label='Enter-number' required>Flight Number</CustomInputLabel>
                <CustomTextField
                  {...InputProps}
                  id='number'
                  fullWidth
                  placeholder='Flight Number'
                  type='text'
                  onChange={(e) => props.onChange(e, null, props.dataIndex)}
                  name='flight_no'
                  value={props.flightFields?.flight_no}
                  error={props.flightErrors?.flight_no}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInputLabel htmlFor='org' aria-label='Enter-origin' required>Origin</CustomInputLabel>
                <FormControl variant='standard' fullWidth error={props.flightErrors?.org}>
                  <CustomAutocomplete
                    disablePortal
                    id='org'
                    options={props.locationList}
                    getOptionLabel={(option) => option.iata_code}
                    onChange={(e, v) => {
                      props.onChange({
                        target: {
                          name: 'org',
                          value: v?.iata_code || e?.target?.value
                        }
                      }, null, props.dataIndex);
                    }
                    }
                    name='org'
                    value={props.scheduleOrgDest?.org}
                    renderInput={(params) =>
                      <CustomTextField
                        {...InputProps}
                        {...params}
                        placeholder='Origin'
                        error={props.flightErrors?.org}
                      // onChange={(newValue) => {
                      //   props.onChange(newValue);
                      // }} 
                      />}
                    fullWidth
                    slotProps={{ paper: { className: styles.selectPaperIp }, }}
                  />
                </FormControl>
                <Checkbox
                  checked={props.flightFields?.org_stn}
                  onChange={(e) => {
                    props.onChange({
                      target: {
                        name: 'org_stn',
                        value: e.target.checked
                      }
                    }, null, props.dataIndex);
                  }}
                  name='org_stn'
                  color='primary'
                  inputProps={{ 'aria-label': 'Return flight' }}
                /> Visible at Origin
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInputLabel htmlFor='dest' aria-label='Enter-destionation' required>Destination</CustomInputLabel>
                <FormControl variant='standard' fullWidth error={props.flightErrors?.dest}>
                  <CustomAutocomplete
                    disablePortal
                    id='dest'
                    options={props.locationList}
                    getOptionLabel={(option) => option.iata_code}
                    onChange={(e, v) => {
                      props.onChange({
                        target: {
                          name: 'dest',
                          value: v?.iata_code || e?.target?.value
                        }
                      }, null, props.dataIndex);
                    }}
                    name='dest'
                    value={props.scheduleOrgDest?.dest}
                    renderInput={(params) =>
                      <CustomTextField
                        {...InputProps}
                        {...params}
                        placeholder='Destination'
                        error={props.flightErrors?.dest}
                      // onChange={(newValue) => {
                      //   props.onChange(newValue);
                      // }}                       
                      />}
                    fullWidth
                    slotProps={{ paper: { className: styles.selectPaperIp } }}
                    className={styles.autoCompleteIp}
                  />
                </FormControl>
                <Checkbox
                  checked={props.flightFields?.dest_stn}
                  onChange={(e) => {
                    props.onChange({
                      target: {
                        name: 'dest_stn',
                        value: e.target.checked
                      }
                    }, null, props.dataIndex);
                  }}
                  name='dest_stn'
                  color='primary'
                  inputProps={{ 'aria-label': 'Return flight' }}
                /> Visible at Destination
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInputLabel id='platform-label' aria-label='Select-platform' required>Platform</CustomInputLabel>
                <FormControl variant='standard' fullWidth error={props.flightErrors?.platform}>
                  <CustomSelect
                    {...SelectInputProps}
                    id='platform'
                    labelId='platform-label'
                    onChange={(e, v) => {
                      props.onChange({
                        target: {
                          name: 'platform',
                          value: v?.props?.value || e?.target?.value
                        }
                      }, null, props.dataIndex);
                    }}
                    name='platform'
                    value={!props.flightFields?.platform ? 'placeholder' : props.flightFields.platform?.toUpperCase()}
                    classes={{ select: !props.flightFields?.platform ? styles.colorPlaceholder : '' }}
                  >
                    <MenuItem value='placeholder' disabled>Select a Platform</MenuItem>
                    {platforms.map((name) => (
                      <MenuItem key={name} value={name?.toUpperCase()}>
                        {name}
                      </MenuItem>
                    ))}
                  </CustomSelect>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInputLabel htmlFor='type' aria-label='Enter-aircraft-type' required>Aircraft Type</CustomInputLabel>
                <CustomTextField
                  {...InputProps}
                  id='type'
                  fullWidth
                  placeholder='Aircraft Type'
                  type='text'
                  onChange={(e) => props.onChange(e, null, props.dataIndex)}
                  name='ac_type'
                  value={props.flightFields?.ac_type}
                  error={props.flightErrors?.ac_type}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInputLabel htmlFor='std' aria-label='Enter-std' required>STD</CustomInputLabel>
                <FormControl variant='standard' fullWidth error={props.flightErrors?.std}>
                  <input
                    id='std'
                    label='STD'
                    name='std'
                    type='time'
                    value={props.flightFields?.std}
                    onChange={(val) => props.changeDateTime(val, 'std', props.dataIndex)}
                    className={`${styles.ipTimePicker} ${styles.w100}`}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between'>
                  <CustomInputLabel htmlFor='sta' aria-label='Enter-sta' required>STA
                  </CustomInputLabel>
                  <Stack direction='row' spacing={2}>
                    <CustomCheckbox
                      control={
                        <Checkbox inputProps={{ 'aria-label': '+1', }} checked={props.flightFields?.sta_next} onChange={(e) => props.changeCheck(e, props.dataIndex)} name='sta_next' disableRipple className={styles.p0} />
                      }
                      label='+1'
                      className={styles.mr0}
                    />
                    <CustomCheckbox
                      control={
                        <Checkbox inputProps={{ 'aria-label': '+2', }} checked={props.flightFields?.sta_next2} onChange={(e) => props.changeCheck(e, props.dataIndex)} name='sta_next2' disableRipple className={styles.p0} />
                      }
                      label='+2'
                      className={styles.mr0}
                    />
                  </Stack>
                </Stack>
                <FormControl variant='standard' fullWidth error={props.flightErrors?.sta}>
                  <input
                    id='sta'
                    label='STA'
                    name='sta'
                    type='time'
                    value={props.flightFields?.sta}
                    onChange={(val) => props.changeDateTime(val, 'sta', props.dataIndex)}
                    className={`${styles.ipTimePicker} ${styles.w100}`}

                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInputLabel htmlFor='from_date' aria-label='Enter-from-date '>From Date</CustomInputLabel>
                <FormControl variant='standard' fullWidth error={props.flightErrors?.from}>
                  <CustomDatePicker
                    slotProps={{
                      textField: {
                        ...InputProps,
                        placeholder: 'From Date',
                        fullWidth: true
                      },
                    }}
                    clearable
                    format='DD MMM YYYY'
                    value={dayjs(moment(props.flightFields?.from, 'YYYY MM DD'))}
                    error={props.flightErrors?.from}
                    helperText={props.flightErrors?.from}
                    onChange={(val) => props.changeDateTime(val, 'from', props.dataIndex)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end' >
                          <QueryBuilderIcon color='primary' />
                        </InputAdornment>
                      )
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInputLabel htmlFor='to_date' aria-label='Enter-to-date'>To Date</CustomInputLabel>
                <FormControl variant='standard' fullWidth error={props.flightErrors?.to}>
                  <CustomDatePicker
                    slotProps={{
                      textField: {
                        ...InputProps,
                        placeholder: 'To Date',
                        fullWidth: true
                      },
                    }}
                    clearable
                    format='DD MMM YYYY'
                    minDate={dayjs(moment(props.flightFields?.from, 'YYYY MM DD'))}
                    value={dayjs(moment(props.flightFields?.to, 'YYYY MM DD'))}
                    error={props.flightErrors?.to}
                    helperText={props.flightErrors?.to}
                    onChange={(val) => props.changeDateTime(val, 'to', props.dataIndex)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end' >
                          <QueryBuilderIcon color='primary' />
                        </InputAdornment>
                      )
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md>
                <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between' className={`${styles.radioLabel} ${flightStyles.pb0}`}>
                  <CustomInputLabel htmlFor='' aria-label='Select-days-of-operation'>Days of operation</CustomInputLabel>
                  <CustomCheckbox
                    control={
                      <Checkbox inputProps={{ 'aria-label': 'ALL', }} className={flightStyles.allCheckbox} checked={props.flightFields?.mon && props.flightFields?.tue && props.flightFields?.wed && props.flightFields?.thu && props.flightFields?.fri && props.flightFields?.sat && props.flightFields?.sun} onChange={(e) => props.changeCheck(e, props.dataIndex)} name='all' />
                    }
                    label='ALL'
                  />
                </Stack>
                <FormGroup row>
                  <CustomCheckbox
                    control={
                      <Checkbox inputProps={{ 'aria-label': 'Monday', }} checked={props.flightFields?.mon} onChange={(e) => props.changeCheck(e, props.dataIndex)} name='mon' />
                    }
                    label='1'
                  />
                  <CustomCheckbox
                    control={
                      <Checkbox inputProps={{ 'aria-label': 'Tuesday', }} checked={props.flightFields?.tue} onChange={(e) => props.changeCheck(e, props.dataIndex)} name='tue' />
                    }
                    label='2'
                  />
                  <CustomCheckbox
                    control={
                      <Checkbox inputProps={{ 'aria-label': 'Wednesday', }} checked={props.flightFields?.wed} onChange={(e) => props.changeCheck(e, props.dataIndex)} name='wed' />
                    }
                    label='3'
                  />
                  <CustomCheckbox
                    control={
                      <Checkbox inputProps={{ 'aria-label': 'Thursday', }} checked={props.flightFields?.thu} onChange={(e) => props.changeCheck(e, props.dataIndex)} name='thu' />
                    }
                    label='4'
                  />
                  <CustomCheckbox
                    control={
                      <Checkbox inputProps={{ 'aria-label': 'Friday', }} checked={props.flightFields?.fri} onChange={(e) => props.changeCheck(e, props.dataIndex)} name='fri' />
                    }
                    label='5'
                  />
                  <CustomCheckbox
                    control={
                      <Checkbox inputProps={{ 'aria-label': 'Saturday', }} checked={props.flightFields?.sat} onChange={(e) => props.changeCheck(e, props.dataIndex)} name='sat' />
                    }
                    label='6'
                  />
                  <CustomCheckbox
                    control={
                      <Checkbox inputProps={{ 'aria-label': 'Sunday', }} checked={props.flightFields?.sun} onChange={(e) => props.changeCheck(e, props.dataIndex)} name='sun' />
                    }
                    label='7'
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </StyledCard>
        </CustomDialogContent>
        <CustomDialogAction className={styles.fSpaceBtw}>
          {!props.flightFields?.conflictId && <CustomButton variant='contained' onClick={() => props.handleCloseSchedule('add')}>Close</CustomButton>}
          <CustomButton variant='contained' type='submit'>{props.flightFields?.id ? 'Update' : 'Submit'}</CustomButton>
          {props.flightFields?.updated && <div style={{ height: 10 }}><TickIcon /> Updated</div>}
        </CustomDialogAction>
      </form>
    </>
  );
};

// Default export: same form, optionally wrapped in a Dialog (pass withDialog={false} to render inline).
const flightScheduleModal = (props) => {
  if (props.withDialog === false) {
    return <FlightScheduleForm {...props} />;
  }
  return (
    <Dialog aria-labelledby='form-dialog-title' open={props.openAddSchedule} onClose={() => props.handleCloseSchedule('add')}>
      <FlightScheduleForm {...props} />
    </Dialog>
  );
};
export default flightScheduleModal;